import {useEffect, useRef, useState} from 'react';

interface BeforeInstallPromptEvent extends Event {
    readonly platforms: Array<string>;
    readonly userChoice: Promise<{
        outcome: 'accepted' | 'dismissed';
        platform: string;
    }>;
    prompt(): Promise<void>;
}


const useBeforeInstallPrompt = () => {
    const installPromptRef = useRef<BeforeInstallPromptEvent | null>(null);
    const [choiceResult, setChoiceResult] = useState<{ outcome: 'accepted' | 'dismissed' | null, platform: string } | null>(null);

    useEffect(() => {
        const handleBeforeInstallPrompt = (event: Event) => {
            event.preventDefault();
            installPromptRef.current = event as BeforeInstallPromptEvent;
        };

        window.addEventListener('beforeinstallprompt', handleBeforeInstallPrompt);

        handleInstallClick();

        return () => {
            window.removeEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
        };
    }, []);

    const handleInstallClick = async () => {
        const currentInstallPrompt = installPromptRef.current;

        if (currentInstallPrompt) {
            try {
                await currentInstallPrompt.prompt();
                const result = await currentInstallPrompt.userChoice;
                setChoiceResult(result);
            } catch (error) {
                console.error('Ошибка во время установки PWA:', error);
            } finally {
                installPromptRef.current = null;
            }
        } else {

        }
    };

    return { installPromptRef, handleInstallClick, choiceResult, };
};

export default useBeforeInstallPrompt;
